import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "report" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportButton',
  props: {
  title: String,
  linkReport: String,
},
  emits: ["openModal", "preview"],
  setup(__props, { emit }) {

const props = __props;





return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('preview'))),
      target: "_blank",
      style: {"margin-right":"15px"}
    }, [
      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-eye" })
    ]),
    _createElementVNode("a", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('openModal'))),
      style: {"margin-right":"15px"}
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: "fa-solid fa-download",
        style: {"margin-right":"15px"}
      }),
      _createElementVNode("span", null, _toDisplayString(__props.title), 1)
    ])
  ]))
}
}

})